import React from "react";
import {AlertCircle} from "react-feather";

const TextInput = ({label, formik, name, disabled = false, inputChange = null, error = false}) => {

    const {handleChange, errors, touched} = formik;


    const showError = (!errors[name] && error) || (touched[name] && errors[name]);

    return <div className="sl-width-100 sl-text-left sl-flex sl-flex-col">
                                <span
                                    className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 "
                                    dangerouslySetInnerHTML={{__html: label}}/>
        <div
            className={` sl-mt-2 sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex sl-relative
            ${showError ? 'sl-border-1 sl-border-solid sl-border-error-300 ' : ''}
            `}>
            <input
                disabled={disabled}
                value={formik.getFieldProps(name).value}
                name={name}
                onKeyDown={inputChange ? inputChange : null}
                onChange={handleChange}
                className={`sl-input sl-border-none sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-m-0 sl-h-11 sl-w-fill-available sl-pl-2 sl-pr-8i`}
                type="text"/>
            {showError &&
                <AlertCircle size={16} className="sl-text-error-500 sl-absolute sl-right-3-point-5 sl-top-3"/>}
        </div>
        {touched[name] && errors[name] &&
            <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>}

        {!errors[name] && error &&
            <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{error}</span>}
    </div>

}

export default TextInput;